import styled from 'styled-components'

export const Content = styled.div`
	padding: 12px 20px;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	align-items: center;
	height: 100%;

	@media (max-width: 800px) {
		display: flex;
		grid-template-columns: 1fr 1fr;
		justify-content: space-between;
	}
`
